<div
  class="fade modal"
  id="planCreateModal"
  tabindex="-1"
  aria-labelledby="planCreateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header w-100 d-flex justify-content-between">
        <h1 class="modal-title fs-5">Creación de plan</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <form
          action=""
          class="d-flex justify-content-center"
          [formGroup]="planForm"
          (ngSubmit)="createPlan()"
        >
          <div
            class="row d-flex flex-lg-row flex-column justify-content-center"
          >
            <div class="d-flex flex-column">
              <select
                class="form-select"
                aria-label="Small select example"
                formControlName="planType"
                (change)="selectPlanType()"
              >
                <option selected [value]="null">Seleccion de plan</option>
                <option *ngFor="let plan of plans" [value]="plan.id">
                  {{ plan.name }}
                </option>
              </select>

              <div class="mt-2">
                <span>Fin de plan</span>
                <select
                  *ngIf="selectedFinishType == 'weeks'"
                  class="form-select"
                  aria-label="Small select example"
                  formControlName="weeks"
                >
                  <option [value]="4">4 Semanas</option>
                  <option [value]="8">8 Semanas</option>
                  <option [value]="12">12 Semanas</option>
                  <option [value]="24">24 Semanas</option>
                  <option [value]="48">48 Semanas</option>
                  <option [value]="9999">Sin vencimiento</option>
                </select>
              </div>
            </div>

            <button class="w-100 btn-custom mt-3" [disabled]="planForm.invalid">
              Crear Plan
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
